import http from '../../utils/http';

export const getUserInfoAPI = (userId) => {
    return http.get('/new/h5/users', {
        params: {
            userId,
            healthExamination: 1,
            isFollow: 1,
            pictureSet: 1,
            isLike: 1,
        }
    });
};

export const actionAPI = (userId, action) => {
    return http.post('/new/h5/users/statistics/personal/action', {
        params: {
            userId,
            action
        }
    });
};


export const getProductsAPI = (userId, index = 0, tag = null) => {
    return http.get('/new/portfolio/product/list', {
        params: {
            userId,
            index,
            tag: tag ? tag.tag : null,
            tagStatistics: 1,
            limit: 10
        }
    }).then(res => {
        if (res.isOk && res.data.data && res.data.data.list && res.data.data.list.length === 10) {
            res.data.loadMore = true
        }
        return res
    });
};

export const getProductListAPI = (params) => {
    return http.get('/new/portfolio/product/list', {
        params
    }).then(res => {
        if (res.isOk && res.data.data && res.data.data.list && res.data.data.list.length > 0) {
            res.data.hasMore = true
        }
        return res
    });
};


export const getCircleAPI = (userId, time) => {
    return http.get('/new/outbox', {
        params: {
            userId,
            time: time,
            limit: 10
        }
    }).then(res => {
        if (res.isOk && res.data.data && res.data.data.length === 10) {
            res.data.loadMore = true
        }
        return res
    });
};


export const getPicturesAPI = (userId, index) => {
    return http.get('/new/users/pictureSet/list', {
        params: {
            ownerId: userId,
            index,
            limit: 10
        }
    }).then(res => {
        if (res.isOk && res.data.data.list && res.data.data.list.length === 10) {
            res.data.loadMore = true
        }
        return res
    });
};


export const getProductAPI = (_id) => {
    return http.get('/new/products/detail', {
        params: {
            _id,
        }
    });
};

export const getTagCategoryList = (params) => {
    return http.get('/new/portfolio/product/tag/category/list', {
        params
    });
};

export const like2 = (feed_id) => {
    return http.post('/new/feeds/detail/like', {
        data: {feed_id}
    })
}

export const disLike = (feed_id) => {
    return http.delete('/new/feeds/detail/like', {
        data: {feed_id}
    })
}


export const getManuscriptAPI = (_id) => {
    return http.get('/new/feeds/detail', {
        params: {
            _id,
        }
    });
};


export const like = (storeId) => {
    return http.post('/new/store/like', {params: {storeId}});
};



// WEBPACK FOOTER //
// ./src/apps/portfolio/apis.js